module.exports = "/_next/static/images/Wireline-53fe57de9d08f1b5fd90f72af9119d4b.webp";